import { Typo } from "../../../Typo";
import { PieData, TranslatedContent } from "../../types";

export const ChartLegend = ({
  data,
  translations,
}: {
  data: PieData[];
  translations: TranslatedContent;
}) => {
  return (
    <div className="flex w-full flex-col justify-center gap-3 lg:w-64">
      {data.map((item) => (
        <div key={item.id} className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div
              className="h-4 w-4 rounded-[4px]"
              style={{ backgroundColor: item.color }}
            />
            <Typo type="labelSM" textColor="text-text-base-secondary">
              {item.label}
            </Typo>
          </div>

          <Typo type="labelSM" textColor="text-text-base-secondary">
            {item.value}&nbsp;
            {item.value > 1
              ? translations.accountReportTab.graphs.accounts
              : translations.accountReportTab.graphs.account}
          </Typo>
        </div>
      ))}
    </div>
  );
};
